import { version } from './sentry-release';

export const environment = {
  production: true, // Use remote server (not local dev server)
  isStaging: false, // Production build - connects to pos.versacommerce.de
  locale: 'de',
  adminSite: 'https://<subdomain>.versacommerce.de/admin/',
  changePinUrl: 'https://<subdomain>.versacommerce.de/admin/settings/users/',
  externalApiBaseUrl: 'https://hub.versacommerce.de',
  appAdminLoginUrl: null,
  pollingDelay: 60 * 1000, // 1 minute
  envConfig: null,
  runAsStandaloneApplication: false,
  runOnAndroidPaymentTerminal: false,
  addTseToInvoice: true,
  sentry: {
    dsn: 'https://45d0b8e48da44c68bf70004b9dca7442@o1421786.ingest.sentry.io/6767985',
    release: version || 'versacommerce-pos@production',
    dist: '1'
  },
};
